<template>
  <div>
    <dp-dropdown>
      <span
        class="text-dark-blue-1000 uppercase font-semibold hover:text-dark-blue-800"
      >
        {{ language }}
      </span>
      <dp-dropdown-menu slot="menu">
        <dp-dropdown-item
          v-for="lang in supportedLanguages"
          :key="lang"
          class="uppercase"
          @click.native="changeLanguage(lang)"
        >
          {{ lang }}
        </dp-dropdown-item>
      </dp-dropdown-menu>
    </dp-dropdown>
  </div>
</template>

<script>
import { Trans } from "../plugins/Translation";

export default {
  name: "LocaleSwitcher",
  data() {
    return {
      language: Trans.currentLanguage,
    };
  },
  computed: {
    supportedLanguages() {
      return Trans.supportedLanguages;
    },
    currentLanguage() {
      return Trans.currentLanguage;
    },
  },
  methods: {
    changeLanguage(lang) {
      this.language = lang;
      return Trans.changeLanguage(lang);
    },
  },
};
</script>
